import * as React from 'react';
import { Helmet } from 'react-helmet-async';
import AdminSideBar from './../../Containers/AdminSideBar';
import { AccountDocsContainer } from '../../Containers/AccountDocsContainer';
import { useTranslation } from 'react-i18next';


function AccountDocs() {
    const { t } = useTranslation();
    return ( 
        <>
            <div className='ContentsWrapper ContentsWrapper2'>
                <Helmet>
                        <meta charSet="utf-8" />
                        <title>
                    {t("st:head.menu")} | {t("head.appTitle")}
                </title>
                </Helmet>
                <AdminSideBar />
                <AccountDocsContainer />
            </div>
        </>
     );
}

export default AccountDocs;